export default __webpack_public_path__ + "static/media/soft5.025a672e.jpg";